import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useEffect } from "react";
import _ from "lodash";
import { useHealthCenterRules } from "../../../../../../../../utils/hooks";

const PresentationPicker = ({ presentations, onSelect, noAutopick }) => {
  const healthCenterMedicinesRules = useHealthCenterRules("medicalDocuments.prescription.medicines");
  const presentationsOrderStrategy = healthCenterMedicinesRules?.presentationsOrderStrategy;

  useEffect(() => {
    if (noAutopick) return;
    if (presentations.length === 1) {
      onSelect(presentations[0]);
    }
  }, [presentations]);

  return (
    <List sx={{ pt: 0 }}>
      {_(presentations)
        .thru(presentations => presentationsOrderStrategy ? _.orderBy(presentations, presentationsOrderStrategy) : presentations)
        .map(presentation => (
          <ListItem disableGutters key={presentation.regNo}>
            <ListItemButton onClick={() => onSelect(presentation)}>
              <ListItemText primary={presentation.displayName} />
          </ListItemButton>
        </ListItem>
      ))
      .value()}
    </List>
  );
};

export default PresentationPicker;